export default "__VITE_ASSET__B2Nrmwf6__"